import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Layout from '../components/Layout';
import { FaEdit, FaTrash, FaPlus } from 'react-icons/fa';
import Swal from 'sweetalert2';

const KategoriBuku = () => {
  const [kategoris, setKategoris] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [formData, setFormData] = useState({ id: null, nama_kategori: '' });

  useEffect(() => {
    fetchKategoris();
  }, []);

  const fetchKategoris = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/kategori`);
      setKategoris(response.data);
      setLoading(false);
    } catch (err) {
      console.error('Error fetching categories:', err);
      setError('Gagal memuat data kategori.');
      setLoading(false);
    }
  };

  const handleInputChange = (e) => {
    setFormData({ ...formData, nama_kategori: e.target.value });
  };

  const handleAddEditSubmit = async (e) => {
    e.preventDefault();
    try {
      if (formData.id) {
        // Update kategori
        await axios.put(`${process.env.REACT_APP_API_URL}/kategori/${formData.id}`, { nama_kategori: formData.nama_kategori });
        Swal.fire('Berhasil', 'Kategori berhasil diperbarui', 'success');
      } else {
        // Tambah kategori baru
        await axios.post(`${process.env.REACT_APP_API_URL}/kategori`, { nama_kategori: formData.nama_kategori });
        Swal.fire('Berhasil', 'Kategori berhasil ditambahkan', 'success');
      }
      setIsModalOpen(false);
      setFormData({ id: null, nama_kategori: '' });
      fetchKategoris(); // Muat ulang data
    } catch (err) {
      console.error('Error saving category:', err);
      Swal.fire('Gagal', err.response?.data?.message || 'Terjadi kesalahan.', 'error');
    }
  };

  const handleEditClick = (kategori) => {
    setFormData({ id: kategori.id, nama_kategori: kategori.nama_kategori });
    setIsModalOpen(true);
  };

  const handleDeleteClick = (id) => {
    Swal.fire({
      title: 'Apakah Anda yakin?',
      text: 'Kategori akan dihapus permanen!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Ya, hapus!',
      cancelButtonText: 'Batal'
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          await axios.delete(`${process.env.REACT_APP_API_URL}/kategori/${id}`);
          Swal.fire('Terhapus!', 'Kategori berhasil dihapus.', 'success');
          fetchKategoris();
        } catch (err) {
          console.error('Error deleting category:', err);
          Swal.fire('Gagal', 'Terjadi kesalahan saat menghapus.', 'error');
        }
      }
    });
  };

  if (loading) {
    return (
      <Layout title="Kategori Buku">
        <p>Memuat data...</p>
      </Layout>
    );
  }

  return (
    <Layout title="Kategori Buku">
      <div className="box">
        <div className="is-flex is-justify-content-space-between is-align-items-center mb-4">
          <div className="field is-grouped">
            <p className="control">
              <span className="select">
                <select>
                  <option>10</option>
                  <option>25</option>
                  <option>50</option>
                </select>
              </span>
            </p>
            <p className="control pt-2">entri</p>
          </div>
          <div className="is-flex">
            <div className="field has-addons">
              <div className="control">
                <input className="input" type="text" placeholder="Pencarian" />
              </div>
            </div>
            <button
              className="button is-info ml-3"
              onClick={() => {
                setFormData({ id: null, nama_kategori: '' });
                setIsModalOpen(true);
              }}
            >
              <FaPlus className="mr-2" />
              Tambah Kategori
            </button>
          </div>
        </div>

        {error && <p className="has-text-danger">{error}</p>}

        <div className="table-container">
          <table className="table is-bordered is-striped is-narrow is-hoverable is-fullwidth">
            <thead>
              <tr>
                <th>No</th>
                <th>Nama Kategori</th>
                <th>Aksi</th>
              </tr>
            </thead>
            <tbody>
              {kategoris.length > 0 ? (
                kategoris.map((kategori, index) => (
                  <tr key={kategori.id}>
                    <td>{index + 1}</td>
                    <td>{kategori.nama_kategori}</td>
                    <td>
                      <button className="button is-small is-info mr-2" onClick={() => handleEditClick(kategori)}>
                        <FaEdit />
                      </button>
                      <button className="button is-small is-danger" onClick={() => handleDeleteClick(kategori.id)}>
                        <FaTrash />
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="3" className="has-text-centered">Tidak ada data kategori.</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      {/* Modal untuk Tambah/Edit Kategori */}
      <div className={`modal ${isModalOpen ? 'is-active' : ''}`}>
        <div className="modal-background" onClick={() => setIsModalOpen(false)}></div>
        <div className="modal-card">
          <header className="modal-card-head">
            <p className="modal-card-title">{formData.id ? 'Edit Kategori' : 'Tambah Kategori'}</p>
            <button className="delete" aria-label="close" onClick={() => setIsModalOpen(false)}></button>
          </header>
          <section className="modal-card-body">
            <form onSubmit={handleAddEditSubmit}>
              <div className="field">
                <label className="label">Nama Kategori</label>
                <div className="control">
                  <input
                    className="input"
                    type="text"
                    placeholder="Masukkan nama kategori"
                    value={formData.nama_kategori}
                    onChange={handleInputChange}
                    required
                  />
                </div>
              </div>
              <div className="field is-grouped is-justify-content-flex-end">
                <div className="control">
                  <button type="submit" className="button is-info">
                    Simpan
                  </button>
                </div>
                <div className="control">
                  <button type="button" className="button" onClick={() => setIsModalOpen(false)}>
                    Batal
                  </button>
                </div>
              </div>
            </form>
          </section>
        </div>
      </div>
    </Layout>
  );
};

export default KategoriBuku;